import React from 'react';

const NavbarList = ({children}) => {
	return (
			<ul
					className="navbar__list"
			>
				{children}
			</ul>
	);
};

export default NavbarList;
